import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { nincdToLongString, nincdToString } from "@/helpers/medicationhelper";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NincdString',
  props: {
    nincd: {},
    long: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const nincdString = computed(() => {
  if (props.long) {
    return nincdToLongString(props.nincd);
  } else {
    return nincdToString(props.nincd);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(nincdString.value) + " ", 1))
}
}

})